import React, { useContext } from 'react';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import formatData from './helpers/formatData';
import { getFormInitialValues } from './helpers/getFormInitialValues';
import { getFormValidationSchema } from './helpers/formValidationSchema';

import { AppContext } from './App';
import { FormikComponent } from './utils/FormikComponent';
import FormikPersist from './utils/FormikPersist';
import DisplayFormikState from './utils/DisplayFormikState';

import { _Button as Button } from './components/Styled/Button';
import { Checkbox } from './components/Formik/Checkbox/Checkbox';
import { usePost } from './hooks/useFetch';
import { ContactDetails } from './components/ContactDetails/ContactDetails';
import ErrorMessage from './components/ErrorMessage/ErrorMessage';
import RightColumn from './components/SkeletonLoaders/RightColumn';

const FormContent = () => {
  const { localization, urlParams, formAttributes, previewMode } = useContext(AppContext);
  const { content, contact } = formAttributes;
  const confirmationPageUrl = formAttributes.confirmationPage
    ? formAttributes.confirmationPage
    : process.env.REACT_APP_CONFIRMATION_PAGE_URL_CHANNEL_1;
  const webhookUrl = process.env.REACT_APP_WEBHOOK_URL;

  const { loading, error, post } = usePost(webhookUrl);

  if (loading) return <RightColumn />;
  if (error) return <ErrorMessage>{error}</ErrorMessage>;

  const handleSubmit = (values) => {
    const formattedData = formatData(values, formAttributes, urlParams, localization.language, localization.marketCode);

    post(formattedData, confirmationPageUrl);
  };

  const initialValues = getFormInitialValues(content, contact);

  const { errorMessages } = localization.text;
  const formValidationSchema = getFormValidationSchema(errorMessages, localization.language);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={formValidationSchema}
      validateOnMount={false}
      validateOnBlur={true}
      validateOnChange={false}
    >
      {(props) =>
        withFormikDevtools(
          props,
          <Form>
            <FormikPersist name={formAttributes.name} />
            {urlParams.debug && <DisplayFormikState />}
            {content.map((item, index) => (
              <div key={index}>{FormikComponent(item)}</div>
            ))}
            <ContactDetails fields={contact} localization={localization} handleChange={props.handleChange} />
            <Checkbox
              id='tacCheckbox'
              props={{
                label: formAttributes.TAC || localization.text.tacLabel,
                required: true,
                name: 'tacCheckbox',
              }}
            />
            <Button id='form-submit-button' name={'submitButton'} type='submit' disabled={loading || previewMode}>
              {localization.text.submitButton}
            </Button>
          </Form>
        )
      }
    </Formik>
  );
};

export default FormContent;
